<template>
  <div>
    <validation-observer ref="form">
        <form novalidate @submit.prevent="saveMedication">
            <mdb-modal side position="right" fullHeight direction="right" :show="modal" @close="close">
                <mdb-modal-header>
                    <mdb-modal-title class="h4">Medikamentenblatt erstellen</mdb-modal-title>
                </mdb-modal-header>
                <mdb-modal-body class="example-card scrollbar-blue thin">
                    <validation-provider
                        name="Ansetzen"
                        rules="required"
                        v-slot="{ errors, valid, validated }"
                        slim
                    >
                        <mdb-date-picker
                          v-model="datum"
                          disabledFuture
                          label="Ansetzen"
                          name="Ansetzen"
                          :option="optionDatePicker"
                          :customValidation="validated"
                          :isValid="valid"
                          :invalidFeedback="errors[0]"
                          validFeedback="sieht gut aus"
                          outline
                          @getValue="getPickersValue"
                        />
                    </validation-provider>
                    <validation-provider
                        name="Absetzen"
                        rules=""
                        v-slot="{ errors, valid, validated }"
                        slim
                    >
                        <mdb-date-picker
                          v-model="endDatum"
                          disabledFuture
                          label="Absetzen"
                          name="Absetzen"
                          :option="optionDatePicker"
                          :customValidation="validated"
                          :isValid="valid"
                          :invalidFeedback="errors[0]"
                          validFeedback="sieht gut aus"
                          outline
                          @getValue="getPickersEndValue"
                        />
                    </validation-provider>
                    <validation-provider
                        name="Medikament"
                        rules="required"
                        v-slot="{ errors, valid, validated }"
                        slim
                    >
                    <mdb-select
                      outline
                      id="Medikament"
                      ref="medikament"
                      v-model="medikamentOptions"
                      label="Medikament"
                      name="Medikament"
                      search
                      searchPlaceholder="Suchen..."
                      @search="handleSearch"
                      disableFilter
                      placeholder="Medikament"
                      validation
                    >
                    <small slot="footer" class="p-2 grey-text">
                      {{
                        loading
                          ? "Verladung..."
                          : medikamentOptions.length === 0
                            ? searchValue === ""
                              ? "Begriff eingeben um zu suchen"
                              : "Keine Ergebnisse gefunden"
                            : "Wähle deine medikament"
                      }}
                    </small>
                    </mdb-select>
                    </validation-provider>
                    <mdb-row class="my-3">
                        <mdb-col sm="8">
                            <validation-provider
                                name="Früh nüchtern"
                                rules="max:30"
                                v-slot="{ errors, valid, validated }"
                                slim
                            >
                                <mdb-input
                                    v-model="form.GabeFN"
                                    label="Früh nüchtern"
                                    name="Früh nüchtern"
                                    class="mt-0 mb-0"
                                    :customValidation="validated"
                                    :isValid="valid"
                                    :invalidFeedback="errors[0]"
                                    validFeedback="sieht gut aus"
                                    outline
                                />
                            </validation-provider>
                        </mdb-col>
                        <mdb-col sm="4">
                            <validation-provider
                                name="Früh"
                                rules="max:30"
                                v-slot="{ errors, valid, validated }"
                                slim
                            >
                                <mdb-input
                                    v-model="form.GabeF"
                                    label="Früh"
                                    name="Früh"
                                    class="mt-0 mb-0"
                                    :customValidation="validated"
                                    :isValid="valid"
                                    :invalidFeedback="errors[0]"
                                    validFeedback="sieht gut aus"
                                    outline
                                />
                            </validation-provider>
                        </mdb-col>
                    </mdb-row>
                    <mdb-row class="my-3">
                        <mdb-col sm="4">
                            <validation-provider
                                name="Mittag"
                                rules="max:30"
                                v-slot="{ errors, valid, validated }"
                                slim
                            >
                                <mdb-input
                                    v-model="form.GabeM"
                                    label="Mittag"
                                    name="Mittag"
                                    class="mt-0 mb-0"
                                    :customValidation="validated"
                                    :isValid="valid"
                                    :invalidFeedback="errors[0]"
                                    validFeedback="sieht gut aus"
                                    outline
                                />
                            </validation-provider>
                        </mdb-col>
                        <mdb-col sm="4">
                            <validation-provider
                                name="Spät"
                                rules="max:30"
                                v-slot="{ errors, valid, validated }"
                                slim
                            >
                                <mdb-input
                                    v-model="form.GabeS"
                                    label="Spät"
                                    name="Spät"
                                    class="mt-0 mb-0"
                                    :customValidation="validated"
                                    :isValid="valid"
                                    :invalidFeedback="errors[0]"
                                    validFeedback="sieht gut aus"
                                    outline
                                />
                            </validation-provider>
                        </mdb-col>
                        <mdb-col sm="4">
                            <validation-provider
                                name="Nacht"
                                rules="max:30"
                                v-slot="{ errors, valid, validated }"
                                slim
                            >
                                <mdb-input
                                    v-model="form.GabeN"
                                    label="Nacht"
                                    name="Nacht"
                                    class="mt-0 mb-0"
                                    :customValidation="validated"
                                    :isValid="valid"
                                    :invalidFeedback="errors[0]"
                                    validFeedback="sieht gut aus"
                                    outline
                                />
                            </validation-provider>
                        </mdb-col>
                    </mdb-row>
                    <mdb-row class="my-3">
                        <mdb-col sm="4">
                            <validation-provider
                                name="Zgabe1"
                                rules="max:30"
                                v-slot="{ errors, valid, validated }"
                                slim
                            >
                                <mdb-input
                                    v-model="form.Zgabe1"
                                    label="Zgabe1"
                                    name="Zgabe1"
                                    class="mt-0 mb-0"
                                    :customValidation="validated"
                                    :isValid="valid"
                                    :invalidFeedback="errors[0]"
                                    validFeedback="sieht gut aus"
                                    outline
                                />
                            </validation-provider>
                        </mdb-col>
                        <mdb-col sm="4">
                            <validation-provider
                                name="Zgabe2"
                                rules="max:30"
                                v-slot="{ errors, valid, validated }"
                                slim
                            >
                                <mdb-input
                                    v-model="form.Zgabe2"
                                    label="Zgabe2"
                                    name="Zgabe2"
                                    class="mt-0 mb-0"
                                    :customValidation="validated"
                                    :isValid="valid"
                                    :invalidFeedback="errors[0]"
                                    validFeedback="sieht gut aus"
                                    outline
                                />
                            </validation-provider>
                        </mdb-col>
                        <mdb-col sm="4">
                            <validation-provider
                                name="Zgabe3"
                                rules="max:30"
                                v-slot="{ errors, valid, validated }"
                                slim
                            >
                                <mdb-input
                                    v-model="form.Zgabe3"
                                    label="Zgabe3"
                                    name="Zgabe3"
                                    class="mt-0 mb-0"
                                    :customValidation="validated"
                                    :isValid="valid"
                                    :invalidFeedback="errors[0]"
                                    validFeedback="sieht gut aus"
                                    outline
                                />
                            </validation-provider>
                        </mdb-col>
                    </mdb-row>
                    <mdb-row class="my-3">
                        <mdb-col sm="4">
                            <validation-provider
                                name="Zgabe4"
                                rules="max:30"
                                v-slot="{ errors, valid, validated }"
                                slim
                            >
                                <mdb-input
                                    v-model="form.Zgabe4"
                                    label="Zgabe4"
                                    name="Zgabe4"
                                    class="mt-0 mb-0"
                                    :customValidation="validated"
                                    :isValid="valid"
                                    :invalidFeedback="errors[0]"
                                    validFeedback="sieht gut aus"
                                    outline
                                />
                            </validation-provider>
                        </mdb-col>
                        <mdb-col sm="4">
                            <validation-provider
                                name="Zgabe5"
                                rules="max:30"
                                v-slot="{ errors, valid, validated }"
                                slim
                            >
                                <mdb-input
                                    v-model="form.Zgabe5"
                                    label="Zgabe5"
                                    name="Zgabe5"
                                    class="mt-0 mb-0"
                                    :customValidation="validated"
                                    :isValid="valid"
                                    :invalidFeedback="errors[0]"
                                    validFeedback="sieht gut aus"
                                    outline
                                />
                            </validation-provider>
                        </mdb-col>
                    </mdb-row>
                    <validation-provider
                        name="Art"
                        rules="required"
                        v-slot="{ errors, valid, validated }"
                        slim
                    >
                        <mdb-select
                          outline
                          id="art"
                          ref="art"
                          v-model="artOptions"
                          label="Art"
                          name="Art"
                          placeholder="Art"
                          validation
                        />
                    </validation-provider>
                    <validation-provider
                        name="Intervall"
                        rules=""
                        v-slot="{ errors, valid, validated }"
                        slim
                    >
                        <mdb-input
                            v-model="form.Intervall"
                            label="Intervall"
                            name="Intervall"
                            :customValidation="validated"
                            :isValid="valid"
                            :invalidFeedback="errors[0]"
                            validFeedback="sieht gut aus"
                            outline
                        />
                    </validation-provider>
                    <validation-provider
                        name="Intervall in Tagen"
                        rules=""
                        v-slot="{ errors, valid, validated }"
                        slim
                    >
                        <mdb-select
                            outline
                            id="intervall"
                            v-model="intervallTagenOptions"
                            label="Intervall in Tagen"
                            name="Intervall in Tagen"
                            placeholder="Intervall in Tagen"
                            :customValidation="validated"
                            :isValid="valid"
                            :invalidFeedback="errors[0]"
                            validFeedback="sieht gut aus"
                        />
                    </validation-provider>
                     <validation-provider
                        name="IntervallText"
                        rules="max:30"
                        v-slot="{ errors, valid, validated }"
                        slim
                    >
                        <mdb-input
                            v-model="form.IntervallText"
                            label="IntervallText"
                            name="IntervallText"
                            :customValidation="validated"
                            :isValid="valid"
                            :invalidFeedback="errors[0]"
                            validFeedback="sieht gut aus"
                            outline
                        />
                    </validation-provider>
                    <validation-provider
                        name="Von wem angesetzt"
                        rules="required|max:30"
                        v-slot="{ errors, valid, validated }"
                        slim
                    >
                        <mdb-input
                            v-model="form.BeginArzt"
                            label="Von wem angesetzt (Arzt)"
                            name="Von wem angesetzt"
                            :customValidation="validated"
                            :isValid="valid"
                            :invalidFeedback="errors[0]"
                            validFeedback="sieht gut aus"
                            outline
                        />
                    </validation-provider>
                    <validation-provider
                        name="Von wem abgesetzt"
                        rules="max:30"
                        v-slot="{ errors, valid, validated }"
                        slim
                    >
                        <mdb-input
                            v-model="form.EndArzt"
                            label="Von wem abgesetzt (Arzt)"
                            name="Von wem abgesetzt"
                            :customValidation="validated"
                            :isValid="valid"
                            :invalidFeedback="errors[0]"
                            validFeedback="sieht gut aus"
                            outline
                        />
                    </validation-provider>
                </mdb-modal-body>
                <mdb-modal-footer>
                    <mdb-btn color="grey lighten-1" @click.native="close">Zurück</mdb-btn>
                    <mdb-btn
                        color="primary"
                        :disabled="loading"
                        type="submit"
                    >
                        <template v-if="!loading">
                        Erstellen <mdb-icon icon="save" />
                        </template>
                        <template v-else>
                        <span
                            class="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Verladung
                        </template>
                    </mdb-btn>
                </mdb-modal-footer>
            </mdb-modal>
        </form>
    </validation-observer>
  </div>
</template>

<script>
  import utils from '@/mixins/Utils'
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbIcon,
    mdbSelect,
    mdbDatePicker,
    mdbRow,
    mdbCol,
    mdbInput
  } from 'mdbvue'

  export default {
    name: 'AddMedicineSheetModal',
    mixins: [utils()],

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbIcon,
      mdbSelect,
      mdbDatePicker,
      mdbRow,
      mdbCol,
      mdbInput
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
      art : {
        type: Array,
        default: null
      }
    },

    data() {
      return {
        modal: false,
        loading: false,
        datum: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        endDatum: '',
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        form: {
          //Medikament: 1,
          GastId: '',
          Datum: '',
          EndDatum: '',
          GabeFN: '',
          GabeF: '',
          GabeM: '',
          GabeS: '',
          GabeN: '',
          Zgabe1: '',
          Zgabe2: '',
          Zgabe3: '',
          Zgabe4: '',
          Zgabe5: '',
          Art: '',
          Intervall: '',
          IntervallZeitpunkt: '',
          IntervallText: '',
          BeginArzt: '',
          EndArzt: '',
          //Angesetzt: true,
          AenderungVon: '',
          AenderungAm: ''
        },
        defaultForm: {
          Medikament: '',
          GastId: '',
          Datum: '',
          EndDatum: '',
          GabeFN: '',
          GabeF: '',
          GabeM: '',
          GabeS: '',
          GabeN: '',
          Zgabe1: '',
          Zgabe2: '',
          Zgabe3: '',
          Zgabe4: '',
          Zgabe5: '',
          Art: '',
          Intervall: '',
          IntervallZeitpunkt: '',
          IntervallText: '',
          BeginArzt: '',
          EndArzt: '',
          //Angesetzt: true,
          AenderungVon: '',
          AenderungAm: ''
        },
        artOptions: [],
        medikamentOptions: [],
        searchValue: "",
      }
    },

    computed: {
      selectedArtData() {
        if(this.artOptions) {
            let response = this.artOptions.find(option => {
            return option.selected === true
            });
            if (response) {
            return response.value
            }
        }
        return ""
      },

      selectedData() {
        let response = this.intervallTagenOptions.find(option => {
          return option.selected === true
        });
        if (response) {
          return response.value
        }
        return ""
      },

      selectedMedicine() {
        const selected = this.medikamentOptions.find(
          option => option.selected
        )
        if (selected === undefined) return ""
        return selected.value
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
      art (v) {
        this.artOptions = v
      },
    },

    created() {
      this.artOptions = this.art
    },

    methods: {
      close () {
        this.$refs.form.reset()
        this.datum = new Date().toJSON().slice(0,10).split('-').reverse().join('-')
        this.endDatum = ''
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes()
        this.$refs.medikament.inputText = null
        this.$refs.medikament.inputValue = null
        this.$refs.art.inputText = null
        this.$refs.art.inputValue = null
        this.form = Object.assign({}, this.defaultForm)
        this.medikamentOptions = []
        this.artOptions.find(option => {
          option.selected = false
        })
        this.intervallTagenOptions.find(option => {
          option.selected = false
        })
        this.$emit('close')
      },

      save () {
        this.close()
        this.$emit('save')
      },

      getPickersValue (value) {
        if(value) {
          this.datum = value
        }
      },

      getPickersEndValue (value) {
        if(value) {
          this.endDatum = value
        }
      },

      handleSearch(value) {
        this.searchValue = value;
        if (value === "" || value.length < 3) {
          this.medikamentOptions = [];
          return;
        }
        this.loading = true;

        this.$http.get(`/Medikamentenblatt/Medikamente/${this.searchValue}`)
          .then(response => {
            if (this.searchValue === "") return;
            const options = response.data.data.map(medicine => {
              return {
                text: medicine.adMedikament_Name, //adMedikament_Wirkstoff
                value: medicine.adMedikament_Id,
                selected: false
              };
            });
            this.medikamentOptions = options;
            this.loading = false;
          })
          .catch(() => {
            this.medikamentOptions = [];
            this.loading = false;
          });
      },

      saveMedication() {
        // select validation check
        this.$refs.medikament.validate()
        if(this.$refs.medikament.inputValue == null || this.$refs.medikament.inputValue == ""){
          this.loading = false
          return
        }

        this.$refs.art.validate()
        if(this.$refs.art.inputValue == null || this.$refs.art.inputValue == ""){
          this.loading = false
          return
        }

        //set select data
        this.form.Art = this.selectedArtData
        this.form.IntervallZeitpunkt = this.selectedData
        this.form.Medikament = this.selectedMedicine

        this.form.Datum = this.formatDateY(this.datum)
        this.form.EndDatum = this.formatDateY(this.endDatum)
        this.form.Datum = this.serverDateFormat(new Date(this.form.Datum+ ' ' +this.uhrzeit))
        this.form.EndDatum = this.form.EndDatum ? this.serverDateFormat(new Date(this.form.EndDatum+ ' ' +this.uhrzeit)) : ''
        this.form.GastId = this.roomID
        this.form.AenderungVon = this.loginUser.username
        this.form.AenderungAm = this.form.Datum

        this.loading = true
        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
          }

          this.$http.post('Medikamentenblatt', this.form)
            .then(res => {
                if(res.data) {
                    this.$notify.success({message: 'Medikamentenblatt erstellen erfolgreich', position: 'top right', closeButton: false, timeOut: 5000})
                    this.save()
                }else {
                    this.$notify.error({message: 'Gescheitert Medikamentenblatt erstellen !!', position: 'top right', closeButton: false, timeOut: 5000})
                }
            })
            .finally(() => {
                this.loading = false
            })
          // Wait until the models are updated in the UI
          this.$nextTick(() => {
            this.$refs.form.reset()
          });
        });
      }
    }
  }
</script>
